import { render, staticRenderFns } from "./VModalGiftGallina.vue?vue&type=template&id=66d495e1&scoped=true&"
import script from "./VModalGiftGallina.vue?vue&type=script&lang=js&"
export * from "./VModalGiftGallina.vue?vue&type=script&lang=js&"
import style0 from "./VModalGiftGallina.vue?vue&type=style&index=0&id=66d495e1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d495e1",
  null
  
)

export default component.exports